/**
 * Where the docs are served — `REACT_APP_DOCS_SITE_URL`, the origin the build writes the sitemap and
 * `llms.txt` with — so the canonical URL and the agent note are the same on every copy of a page,
 * prerendered or not. Without it (local development) the page's own origin.
 */
export const siteOrigin = (): string => process.env.REACT_APP_DOCS_SITE_URL?.replace(/\/+$/, "") ?? (typeof window === "undefined" ? "" : window.location.origin);
